import { render } from "./HomeDoubleSection.vue?vue&type=template&id=d2066cb6&scoped=true"
import script from "./HomeDoubleSection.vue?vue&type=script&lang=js"
export * from "./HomeDoubleSection.vue?vue&type=script&lang=js"

import "./HomeDoubleSection.vue?vue&type=style&index=0&id=d2066cb6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2066cb6"]])

export default __exports__